import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import SearchBar from 'components/SearchBar';
// import useWindowSize from 'components/useWindowSize';
import Hidden from '@material-ui/core/Hidden';
import ButtonBase from '@material-ui/core/ButtonBase';
import _isEmpty from 'lodash/isEmpty';
import ClassNames from 'classnames';
import MenuInActive from '../images/hamburger-menu.svg';
import SearchIcon from '../images/search.svg';
import Logo from './Logo';
import SubMenu from './SubMenu';
import NavBarContext from '../navBarContext';

const useStyles = makeStyles(theme => ({
  toolBar: {
    padding: 0,
    height: 100,
  },
  isEmbed: {
    height: 60,
    [theme.breakpoints.up('600')]: {
      height: 0,
      minHeight: 0,
    },
  },
  mainHeaderWrapper: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const MENU = [
  {
    slug: 'topics',
    name: 'Topics',
  },
  {
    slug: 'assessments',
    name: 'Assessments',
  },
  {
    slug: 'blogs',
    name: 'Blogs',
  },
  {
    slug: 'news',
    name: 'News',
  },
  {
    slug: 'client-exclusive',
    name: 'Client Exclusive',
  },
  {
    slug: 'covid-19',
    name: 'COVID-19',
  },
  {
    slug: 'in-crisis',
    name: 'In Crisis',
  },
];

function Content() {
  const classes = useStyles();
  const [showSearch, setShowSearch] = useState(false);
  const { clientDetails, clientFetching, openDialog, isEmbed } = useContext(
    NavBarContext,
  );
  const hasClientDetails = !_isEmpty(clientDetails) && !clientFetching;
  return (
    <>
      <Toolbar
        className={ClassNames(classes.toolBar, { [classes.isEmbed]: isEmbed })}
      >
        <Grid
          container
          direction="row"
          alignItems="center"
          className={classes.mainHeaderWrapper}
        >
          {!isEmbed && (
            <Hidden xsDown>
              <Grid
                item
                xs={hasClientDetails ? 7 : 6}
                className={classes.logoWrapper}
              >
                <Logo />
              </Grid>
              <Grid item xs={hasClientDetails ? 5 : 6}>
                <SearchBar />
              </Grid>
            </Hidden>
          )}
          <Hidden smUp>
            {showSearch ? (
              <SearchBar isFlat close={() => setShowSearch(false)} />
            ) : (
              <>
                <ButtonBase
                  variant="contained"
                  onClick={() => openDialog(true)}
                  disableRipple
                >
                  <img src={MenuInActive} alt="Menu" className={classes.icon} />
                </ButtonBase>
                <Logo />
                <ButtonBase onClick={() => setShowSearch(true)}>
                  <img src={SearchIcon} alt="Search" />
                </ButtonBase>
              </>
            )}
          </Hidden>
        </Grid>
      </Toolbar>

      <SubMenu menu={MENU} />
    </>
  );
}

export default Content;
